export const scrollToLeadForm = (intent) => {
  const el = document.getElementById("lead");
  if (!el) {
    window.location.href = intent ? `/?intent=${intent}#lead` : "/#lead";
    return;
  }
  if (intent) {
    window.dispatchEvent(new CustomEvent("nb:set-intent", { detail: intent }));
  }
  el.scrollIntoView({ behavior: "smooth", block: "start" });
};
